module.exports = __webpack_public_path__ + "img/newsImg.26161e78.png";